import { BooleanOperator } from 'src/enums/stowage/stowageRule/booleanOperator';
import { StowageRuleConsequenceType } from 'src/enums/stowage/stowageRule/stowageRuleConsequenceType';
import { StowageRuleId } from 'src/enums/stowage/stowageRule/stowageRuleId';
import { StowageRulePropertyLocation } from 'src/enums/stowage/stowageRule/stowageRulePropertyLocation';
import { StowageRulePropertyOperator } from 'src/enums/stowage/stowageRule/stowageRulePropertyOperator';
import { StowageRuleTestScope } from 'src/enums/stowage/stowageRule/stowageRuleTestScope';
import { StowageRuleBM } from 'src/types/BusinessModel/Stowage/StowageRule/StowageRuleBM';

export const ibc15_14SoftRule = {
    id: StowageRuleId.Ibc15_14SoftRule,
    name: 'IBC 15.14 Cargoes with a vapour pressure greater than 0.1013 MPa absolute at 37.8°C stowed in any tank.',
    lastUpdatedUtc: '2014-10-07T13:24:00',
    condition: {
        operator: BooleanOperator.AND,
        children: [
            {
                leaf: {
                    properties: [
                        {
                            name: 'Product category specific and operational requirements',
                            fieldPath: 'cargo.product.category.ibcSpecificRequirements',
                            type: 'array',
                            location: StowageRulePropertyLocation.Tank,
                        },
                        {
                            name: 'IBC chapter 15.14',
                            type: 'string',
                            referenceValue: 'IBC-15.14',
                            location: StowageRulePropertyLocation.NA,
                        },
                    ],
                    scope: StowageRuleTestScope.Tank,
                    operator: StowageRulePropertyOperator.Contains,
                },
            },
            {
                leaf: {
                    properties: [
                        {
                            name: 'Tank content weight',
                            fieldPath: 'getStowedWeight',
                            type: 'number',
                            location: StowageRulePropertyLocation.Tank,
                        },
                        {
                            name: 'Reference value',
                            type: 'number',
                            referenceValue: '0',
                            location: StowageRulePropertyLocation.NA,
                        },
                    ],
                    scope: StowageRuleTestScope.Tank,
                    operator: StowageRulePropertyOperator.IsGreaterThan,
                },
            },
        ],
    },
    consequence: {
        type: StowageRuleConsequenceType.SoftRule,
        parameter: 'Please check in COF/Appendix to class certificate/PO manual if this product is approved for this tank.',
    },
} as StowageRuleBM;
